import { createAction } from 'redux-create-action';
import { ACTIONS } from './constants';

export const initContainer = createAction(ACTIONS.INIT_CONTAINER);
export const exitContainer = createAction(ACTIONS.EXIT_CONTAINER);

export const loadReturns = createAction(ACTIONS.LOAD_RETURNS);
export const loadReturnsSuccess = createAction(ACTIONS.LOAD_RETURNS_SUCCESS, 'payload');
export const loadReturnsError = createAction(ACTIONS.LOAD_RETURNS_ERROR, 'errorMessage', 'error');

export const loadFeed = createAction(ACTIONS.LOAD_FEED);
export const setColumns = createAction(ACTIONS.SET_COLUMNS, 'columns');
export const setColumnsOrder = createAction(ACTIONS.SET_COLUMNS_ORDER, 'columnsOrder');
export const setColumnEnabled = createAction(ACTIONS.SET_COLUMN_ENABLED, 'columnId', 'enabled');
export const setItemsPerPage = createAction(ACTIONS.SET_ITEMS_PER_PAGE, 'itemsPerPage');

export const showOptionsModal = createAction(ACTIONS.SHOW_OPTIONS_MODAL, 'showOptionsModal');
export const refreshReturnFeed = createAction(ACTIONS.REFRESH_RETURNS_FEED);
export const sortReturnFeed = createAction(ACTIONS.SORT_RETURN_FEED, 'columnId', 'direction');
export const setFilterOperand = createAction(ACTIONS.SET_FILTER_OPERAND, 'operand');
export const unsetFilterOperand = createAction(
  ACTIONS.UNSET_FILTER_OPERAND,
  'groupIndex',
  'filterIndex',
);

export const clearFilters = createAction(ACTIONS.CLEAR_FILTERS);
export const setFilters = createAction(ACTIONS.SET_FILTERS, 'filters');
export const arrangeFilters = createAction(ACTIONS.ARRANGE_FILTERS, 'destination', 'source');

export const goToPage = createAction(ACTIONS.GO_TO_PAGE, 'lastPage');

export const exportToFile = createAction(ACTIONS.EXPORT_TO_FILE);
export const exportToFileSuccess = createAction(ACTIONS.EXPORT_TO_FILE_SUCCESS, 'payload');
export const exportToFileError = createAction(
  ACTIONS.EXPORT_TO_FILE_ERROR,
  'errorMessage',
  'error',
);
export const showAddNewReturnModal = createAction(
  ACTIONS.SHOW_ADD_RETURN_MODAL,
  'showAddNewReturnModal',
);
export const returnOrder = createAction(ACTIONS.RETURN_ORDER, 'orderLine');
export const addReturnData = createAction(ACTIONS.ADD_RETURN_DATA, 'returnData');
export const submitAddNewReturnSuccess = createAction(
  ACTIONS.ADD_RETURN_DATA_SUCCESS,
  'returnData',
);

export const submitAddNewReturnSucesss = createAction(ACTIONS.ADD_RETURN_DATA_SUCCESS, 'payload');
export const submitAddNewReturnError = createAction(
  ACTIONS.ADD_RETURN_DATA_ERROR,
  'errorMessage',
  'error',
);

export const getFilteredReturnsFeed = createAction(
  ACTIONS.GET_FILTERED_INVENTORY_ATS,
  'params',
  'successActionCallback',
  'errorActionCallback',
);
export const setFilterOptions = createAction(ACTIONS.SET_FILTER_OPTIONS, 'filterOptions');
export const setColumnFilterOptions = createAction(
  ACTIONS.SET_COLUMN_FILTER_OPTIONS,
  'columnFilterOptions',
);
